<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">{{ relativeTimeString }} </span>
    </template>
    <span>{{ dateTimeString }}</span>
  </v-tooltip>
</template>

<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/es'
dayjs.extend(relativeTime)
dayjs.locale('es')

export default {
  props: {
    date: {
      type: String,
      required: true
    }
  },

  computed:{
    relativeTimeString(){
      return dayjs(this.date).fromNow()
    },
    dateTimeString(date){
      return dayjs(this.date).format('MMM D, YYYY h:mm A')
    },
  }
}
</script>